import type { KeyframeEntryT } from '../types';

// Inserts or updates a keyframe entry sorted by frameIndex.
// If an entry for the same frameIndex already exists its type is updated in-place.
export function sortedInsertKeyframe(arr: KeyframeEntryT[], entry: KeyframeEntryT): KeyframeEntryT[] {
  const idx = arr.findIndex(k => k.frameIndex >= entry.frameIndex);
  if (idx === -1) {
    return [...arr, entry];
  }
  if (arr[idx]?.frameIndex === entry.frameIndex) {
    return [...arr.slice(0, idx), entry, ...arr.slice(idx + 1)];
  }
  return [...arr.slice(0, idx), entry, ...arr.slice(idx)];
}